
import { defineComponent } from "vue";
import api, { SheqsyCompanyList, SheqsyCompany, RequestPaging, PageBounding, RequestSort } from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { dateDiff, getHumanDate } from "../../util/luxonDateHelpers"
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: SheqsyCompanyList;
  requestFilter: SheqsyCompanyRequestFilter;
  requestPaging: RequestPaging;
  requestSorting: RequestSort,
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

interface SheqsyCompanyRequestFilter extends SheqsyCompany {
  export_required?: number
}

export default defineComponent({
  name: "SheqsyCompany",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  data: (): State => {
    const company_list = { } as SheqsyCompanyList;
    const company_struct = { } as SheqsyCompany;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    return {
      msg: "Sheqsy Company List",
      backendResponse: company_list,
      requestFilter: company_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as SheqsyCompany;
      this.requestFilter = filter_struct;
      this.getList()
    },
    status(company: SheqsyCompany): string {
        if (!company.LastUpdate) return "No Updates"
        if (company.LastExport) {
            const _age = dateDiff(company.LastExport, company.LastUpdate)
            if (_age <= 0) return "OK"
        }
        return "Updated " + getHumanDate(company.LastUpdate)
    },
    processRequestFilter(filter: SheqsyCompanyRequestFilter): SheqsyCompany {
        let _filter = {} as SheqsyCompany
        let _proto: {[key: string]: any} = {}
        for (const [_k, _v] of Object.entries(filter)) {
            if (_v == "") continue
            if (_k == 'export_required') {
                _proto['$expr'] = (_v == "1"
                    ? {"$lt": ["$LastExport", "$LastUpdate"]}
                    : {"$gte": ["$LastExport", "$LastUpdate"]}
                )
                continue
            }
            _proto[_k] = _v
        }
        if (Object.keys(_proto).length) {
            Object.assign(_filter, _proto)
        }
        
        return _filter
    },
    getList() {
      this.backendResponse = { } as SheqsyCompanyList;
      const request_params = api.createRequestParams(this.processRequestFilter(this.requestFilter), this.requestPaging, this.requestSorting)
      api
        .getSheqsyCompanyList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
